import React from 'react'

const Suplychainheader = () => {
  return (
   <div className="pcb-header">
      <div className="pcb-overlay">
        <div className="pcb-content">
          <h1 className="pcb-title">Supply Chain & Logistics
</h1>
          <p className="pcb-subtitle">
       Streamlined Supply Chain Solutions – On-Time, Every Time
          </p>
        </div>
      </div>

   
      <svg className="pcb-curve" viewBox="0 0 1440 100" preserveAspectRatio="none">
        <path
          d="M0,0 C480,100 960,100 1440,0 L1440,100 L0,100 Z"
          fill="#ffffff"
        />
      </svg>
    </div>
  )
}

export default Suplychainheader
